import React from "react";
import LegalPageLayout from "../components/LegalPageLayout";
import { cookieContent, getDateLocale } from "../translations/legalContent";

export default function CookiePolicy() {
  return (
    <LegalPageLayout
      titleKey="cookieTitle"
      renderContent={(lang) => {
        const content = cookieContent[lang] || cookieContent.tr;
        const locale = getDateLocale(lang);

        return (
          <>
            <p>
              {content.lastUpdatedLabel} {new Date().toLocaleDateString(locale)}
            </p>

            {content.sections.map((section, i) => (
              <section key={i}>
                <h2>{section.title}</h2>
                {section.paragraphs?.map((p, j) => (
                  <p key={j}>{p}</p>
                ))}
                {section.subSections?.map((sub, j) => (
                  <div key={j}>
                    <h3>{sub.subTitle}</h3>
                    {sub.paragraphs?.map((p, k) => (
                      <p key={k}>{p}</p>
                    ))}
                  </div>
                ))}
                {section.items && (
                  <ul>
                    {section.items.map((item, k) => (
                      <li key={k}>{item}</li>
                    ))}
                  </ul>
                )}
              </section>
            ))}
          </>
        );
      }}
    />
  );
}
